const currencyBasedLocale = { USD: "en-US", GBP: "en-GB" };

export function currencyFormatter(currency: string) {
  return new Intl.NumberFormat(
    currencyBasedLocale[
      currency.toUpperCase() as keyof typeof currencyBasedLocale
    ],
    {
      style: "currency",
      currency,
    },
  );
}

export function fetchRequest(url: string, payload: string) {
  const journeyTokenElement = document.querySelector("[name='journey_token']");
  const authenticityTokenElement = document.querySelector(
    "[name='authenticity_token']",
  );

  if (!journeyTokenElement || !authenticityTokenElement) {
    return Promise.reject(new Error("Tokens not found"));
  }

  const journeyToken = (journeyTokenElement as HTMLInputElement).value;
  const authenticityToken = (authenticityTokenElement as HTMLInputElement)
    .value;

  return fetch(`${url}&journey_token=${journeyToken}`, {
    method: "POST",
    body: payload,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": authenticityToken,
    },
  })
    .then(result => {
      return result.json();
    })
    .then(json => {
      return Promise.resolve(json);
    })
    .catch(error => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      return Promise.reject(new Error(error));
    });
}
